import { render } from "./menuSection.vue?vue&type=template&id=1b8629c4&scoped=true"
import script from "./menuSection.vue?vue&type=script&lang=js"
export * from "./menuSection.vue?vue&type=script&lang=js"

import "./menuSection.vue?vue&type=style&index=0&id=1b8629c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8629c4"]])

export default __exports__